import request from '@/utils/seftRequest';

// 查询订户Detail详情
export function qryBindSubsDetailBsnl(params) {
  return request('/ding/custService/qryBindSubsDetailBsnl', {
    params,
  });
}

// 绑定用户近期充值记录查询接口
export function qryBindSubsRechargeRecently(params) {
  return request('/ding/subsService/qryBindSubsRechargeRecently', {
    method: 'POST',
    body: params,
  });
}

// 绑定用户当月宽带使用信息查询接口
export function qryBindSubsBBUageCurrent(params) {
  return request('/ding/subsService/qryBindSubsBBUageCurrent', {
    method: 'POST',
    body: params,
  });
}
